import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, map } from 'rxjs';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { ConfirmmodalserviceService } from 'src/app/Shared/confirm-delete-modal/confirmmodalservice.service';
import { environment } from 'src/environments/environment';
import { DBConfigDTO, DBConfigReadAllRequestDTO } from '../dbconfig/dbconfig.interface';
import { DBConfigService } from '../dbconfig/dbconfig.service';
import { EmailConfigDTO, EmailConfigReadAllRequestDTO } from '../email-config/email-config.interface';
import { EmailConfigService } from '../email-config/email-config.service';
import { AlertsServiceMasterCreateRequestDTO, AlertsServiceMasterDeleteRequestDTO, AlertsServiceMasterDTO, AlertsServiceMasterReadAllPaginatedRequestDTO, AlertsServiceMasterUpdateRequestDTO, AlertsServiceMasterUpdateStatusRequestDTO } from './services.interface';
import { AlertServiceMasterService } from './services.services';
import { AlertsServiceVariablesCreateRequestDTO } from './variables/alertServiceVariable.interface';
import { AlertsServiceVariablesService } from './variables/alertServiceVariable.service';
import { WhatsappConfigService } from '../whatsapp-config/whatsapp-config.service';
import { WhatsAppConfigDTO } from '../whatsapp-config/whatsapp-config.interface';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit {

  // flags
  isLoading: boolean = false;
  activatedRoute = inject(ActivatedRoute)
  isAlertSubmitFormSubmitted: boolean = false;
  isServiceVariableFormSubmitted: boolean = false;

  // services 
  router = inject(Router);
  private route = inject(ActivatedRoute);
  private confirmModal = inject(ConfirmmodalserviceService);
  public modalService = inject(NgbModal);
  User = inject(UserLoginService).User();
  alertServiceService = inject(AlertServiceMasterService);
  dbConfigService = inject(DBConfigService);
  emailConfigService = inject(EmailConfigService);
  alertServiceVariable = inject(AlertsServiceVariablesService);
  whatsappConfigService = inject(WhatsappConfigService);

  // Items 
  serviceList: AlertsServiceMasterDTO[] = [];
  dbConnectionList: DBConfigDTO[] = [];
  emailFromList: EmailConfigDTO[] = [];
  whatsappConfigList: WhatsAppConfigDTO[] = []
  varTypeOptions: string[] = ['INT', 'STRING'];

  // Modal References 
  @ViewChild('serviceMasterModalContent', { static: false }) addServiceModalContent!: ElementRef;
  addServiceModal!: NgbModalRef;
  @ViewChild('serviceVariableModalContent', { static: false }) addServiceVariableModalContent!: ElementRef;
  addServiceVariableModal!: NgbModalRef;

  alertServiceForm = new FormGroup({
    serviceId: new FormControl(0),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    softwareId: new FormControl(0),
    title: new FormControl('', Validators.required),
    sDesc: new FormControl('', Validators.required),
    alertType: new FormControl('', Validators.required),
    hasAttachment: new FormControl(false),
    attachmentType: new FormControl(''),
    attachmentPath: new FormControl(''),
    attachmentFileType: new FormControl(''),
    outputFileName: new FormControl(''),
    dataSourceType: new FormControl('', Validators.required),
    dataSourceDef: new FormControl(''),
    postSendDataSourceType: new FormControl(''),
    postSendDataSourceDef: new FormControl(''),
    emailTo: new FormControl(''),
    ccTo: new FormControl(''),
    bccTo: new FormControl(''),
    aSubject: new FormControl(''),
    aBody: new FormControl(''),
    waTemplateName: new FormControl(''),
    waTemplate: new FormControl(''),
    waLanguageCode: new FormControl(''),
    dbConnid: new FormControl(0, [Validators.required, Validators.min(1)]),
    alertConfigId: new FormControl(0),
    schedularId: new FormControl(0),
    lastExecutedOn: new FormControl<Date | null>(null),
    nextExecutionTime: new FormControl<Date | null>(null),
    isActive: new FormControl(1),
    isDeleted: new FormControl(0),
    createdBy: new FormControl(''),
    createdOn: new FormControl(0),
    modifiedBy: new FormControl(''),
    modifiedOn: new FormControl(0),
    showPostForm: new FormControl(false),
    showAddScheduler: new FormControl(false)
  });

  serviceVariableForm = new FormGroup({
    variableId: new FormControl(0),
    serviceId: new FormControl(0, [Validators.required]),
    varInstance: new FormControl(''),
    varValue: new FormControl(''),
    varType: new FormControl(''),
    isActive: new FormControl(0)
  })

  whatsAppConfigForm = new FormGroup({
    whatsappConfigId: new FormControl(0),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    softwareId: new FormControl(0),
    iName: new FormControl(''),
    iDesc: new FormControl(''),
    wAUrl: new FormControl(''),
    VersionNo: new FormControl(''),
    phoneNo: new FormControl(''),
    PhoneNoId: new FormControl(''),
    UserAccessToken: new FormControl(''),
    WABAId: new FormControl(''),
    isActive: new FormControl(1), 
    isDeleted: new FormControl(0),
    createdBy: new FormControl(''),
    createdOn: new FormControl(0),
    modifiedBy: new FormControl(''),
    modifiedOn: new FormControl(0),
  })

  PaginatedDTO: AlertsServiceMasterReadAllPaginatedRequestDTO = {
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
    softwareId: parseInt(environment.SoftwareId),
    pageNo: 1,
    pageSize: 10,
    rowNum: 0,
    totalCount: 0,
    whereClause: '',
    orderByClause: '',
  }
  searchText: any;


  ngOnInit(): void {

    let currentParams = this.route.snapshot.queryParams;
    let view = currentParams['view'] ?? 'Grid';
    this.selectedTab = view;

    if (Object.keys(currentParams).length === 0) {
      this.router.navigate(['.'], {
        queryParams: { pageNo: this.PaginatedDTO.pageNo, pageSize: this.PaginatedDTO.pageSize, view: this.selectedTab },
        relativeTo: this.route,
        replaceUrl: true // Replaces the current URL in the history
      });
    } else {
      this.PaginatedDTO.pageSize = currentParams['pageSize'];
      this.PaginatedDTO.pageNo = currentParams['pageNo'];
      //this.selectedTab = currentParams['tab'] ;
    }
    this.getAlertServiceList(this.PaginatedDTO);
    this.getEmailFromList();
    this.getDBConnectionList();
    this.getWhatsAppConfigList();
  }

  handlePageSizeChange(event: { currentPage: number; pageSize: number; }) {
    const { currentPage, pageSize } = event

    this.PaginatedDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId),

      pageNo: currentPage,
      pageSize: pageSize,
    }

    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: { pageNo: this.PaginatedDTO.pageNo, pageSize: this.PaginatedDTO.pageSize, view: this.selectedTab },
      queryParamsHandling: 'merge', // Use 'merge' to merge with existing query parameters
    });

    this.getAlertServiceList(this.PaginatedDTO);
  }

  getAlertServiceList(data: AlertsServiceMasterReadAllPaginatedRequestDTO) {
    this.isLoading = true;
    this.alertServiceService.AlertServiceMaster_ReadAllPaginated(data).subscribe((res) => {
      this.serviceList = res.items.map(items => ({
        ...items,
        statusText: items.isActive === 1 ? "Active" : "Inactive"
      }))
      this.isLoading = false;
    })
  }

  getDBConnectionList() {
    let data: DBConfigReadAllRequestDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId)
    }

    this.dbConfigService.DBConfig_readAll(data).subscribe((res) => {
      this.dbConnectionList = res.items;
    })
  }

  getEmailFromList() {
    let data: EmailConfigReadAllRequestDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId)
    }

    this.emailConfigService.EmailConfig_readAll(data).subscribe((res) => {
      this.emailFromList = res.items;
    })
  }

  getWhatsAppConfigList() {

    this.whatsappConfigService.WhatsAppConfig_readAll().subscribe((res) => {
      this.whatsappConfigList = res.items;
    })
  }

  getWhatsAppConfigData(id: number | null) {
    console.log('id ',id);
    console.log('whatsapp ',this.whatsappConfigList.find(
    x => x.waConfigId == id
  ));
  if (!id) return null;

  return this.whatsappConfigList.find(
    x => x.waConfigId == id
  );

}

  getServiceVariables() {

  }

  openAlertServiceFormModal() {
    this.currentStep = 1;
    this.alertServiceForm.reset();
    this.alertServiceForm.patchValue({
      companyId: Number(this.User.companyId),
      branchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId)
    })


    this.addServiceModal = this.modalService.open(this.addServiceModalContent, {
      size: 'xl',
      backdrop: 'static'
    });

  }

  submitAlertServiceForm() {

    this.alertServiceForm.markAllAsTouched();

    if (this.alertServiceForm.invalid) {
      return;
    }

    if (this.alertServiceForm.valid) {
      this.isAlertSubmitFormSubmitted = true;
      let formData = { ...this.alertServiceForm.value }
      if (this.alertServiceForm.value.serviceId && this.alertServiceForm.value.serviceId !== 0) {
        let data: AlertsServiceMasterUpdateRequestDTO = {
          serviceId: formData.serviceId!,
          tenantId: formData.companyId!,
          tenantBranchId: formData.branchId!,
          softwareId: formData.softwareId!,
          title: formData.title!,
          sDesc: formData.sDesc ?? "",
          alertType: formData.alertType ?? "",
          hasAttachment: formData.hasAttachment ? 1 : 0, // Convert boolean to 1 or 0,
          attachmentType: formData.attachmentType ?? "",
          attachmentPath: formData.attachmentPath ?? "",
          attachmentFileType: formData.attachmentFileType ?? "",
          outputFileName: formData.outputFileName ?? "",
          dataSourceType: formData.dataSourceType ?? "",
          dataSourceDef: formData.dataSourceDef ?? "",
          postSendDataSourceType: formData.postSendDataSourceType ?? "",
          postSendDataSourceDef: formData.postSendDataSourceDef ?? "",
          emailTo: formData.emailTo ?? "",
          ccTo: formData.ccTo ?? "",
          bccTo: formData.bccTo ?? "",
          aSubject: formData.aSubject ?? "",
          aBody: formData.aBody ?? "",
          waTemplateName: formData.waTemplateName ?? "",
          waTemplate: formData.waTemplate ?? "",
          waLanguageCode: formData.waLanguageCode ?? "",
          dbConnid: Number(formData.dbConnid) ?? "",
          alertConfigId: Number(formData.alertConfigId) ?? "",
          schedularId: Number(formData.schedularId) ?? "",
          lastExecutedOn: formData.lastExecutedOn ? new Date(formData.lastExecutedOn) : null,
          nextExecutionTime: formData.nextExecutionTime ? new Date(formData.nextExecutionTime) : null,
          actionUser: this.User.userId.toString(),
          isActive: 1
        }

        this.alertServiceService.AlertServiceMaster_update(data).subscribe((res) => {
          this.getAlertServiceList(this.PaginatedDTO);
          this.addServiceModal.close();
          this.isAlertSubmitFormSubmitted = false;
        })

      } else {
        let data: AlertsServiceMasterCreateRequestDTO = {
          tenantId: formData.companyId!,
          tenantBranchId: formData.branchId!,
          softwareId: formData.softwareId!,
          title: formData.title!,
          sDesc: formData.sDesc ?? "",
          alertType: formData.alertType ?? "",
          hasAttachment: formData.hasAttachment ? 1 : 0, // Convert boolean to 1 or 0,
          attachmentType: formData.attachmentType ?? "",
          attachmentPath: formData.attachmentPath ?? "",
          attachmentFileType: formData.attachmentFileType ?? "",
          outputFileName: formData.outputFileName ?? "",
          dataSourceType: formData.dataSourceType ?? "",
          dataSourceDef: formData.dataSourceDef ?? "",
          postSendDataSourceType: formData.postSendDataSourceType ?? "",
          postSendDataSourceDef: formData.postSendDataSourceDef ?? "",
          emailTo: formData.emailTo ?? "",
          ccTo: formData.ccTo ?? "",
          bccTo: formData.bccTo ?? "",
          aSubject: formData.aSubject ?? "",
          aBody: formData.aBody ?? "",
          waTemplateName: formData.waTemplateName ?? "",
          waTemplate: formData.waTemplate ?? "",
          waLanguageCode: formData.waLanguageCode ?? "",
          dbConnid: Number(formData.dbConnid) ?? "",
          alertConfigId: Number(formData.alertConfigId) ?? "",
          schedularId: Number(formData.schedularId) ?? "",
          lastExecutedOn: formData.lastExecutedOn ? new Date(formData.lastExecutedOn) : null,
          nextExecutionTime: formData.nextExecutionTime ? new Date(formData.nextExecutionTime) : null,
          actionUser: this.User.userId.toString()
        }

        this.alertServiceService.AlertServiceMaster_create(data).subscribe((res) => {
          this.getAlertServiceList(this.PaginatedDTO);
          this.addServiceModal.close();
          this.isAlertSubmitFormSubmitted = false;
        })
      }
    }
  }

  searchEmail = (text$: any) => {
    return text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => {
        const lowerTerm = term.toLowerCase();
        return this.emailFromList
          .filter(email =>
            email.iName!.toLowerCase().includes(lowerTerm) ||
            email.iFrom!.toLowerCase().includes(lowerTerm)
          )
          .slice(0, 10);
      })
    );
  };

  emailFormatter = (email: EmailConfigDTO) => `${email.iName} (${email.iFrom})`;

  onEmailSelected(event: any) {
    const selectedEmail: EmailConfigDTO = event.item;
    this.alertServiceForm.patchValue({
      alertConfigId: selectedEmail.emailConfigId
    });
  }

  handleActionClick(event: { actionName: string; rowData: AlertsServiceMasterDTO; }) {
    const rowData = { ...event.rowData };

    if (event.actionName === 'Edit') {
      this.currentStep = 1;
      this.alertServiceForm.reset();
      this.addServiceModal = this.modalService.open(this.addServiceModalContent, {
        size: 'xl',
        backdrop: 'static'
      });

      this.alertServiceForm.patchValue({
        serviceId: rowData.serviceId,
          companyId: rowData.tenantId!,
          branchId: rowData.tenantBranchId!,
        softwareId: rowData.softwareId!,
        title: rowData.title ?? '',
        sDesc: rowData.sDesc ?? '',
        alertType: rowData.alertType ?? '',
        hasAttachment: rowData.hasAttachment === 1, // Convert 1/0 to true/false
        attachmentType: rowData.attachmentType ?? '',
        attachmentPath: rowData.attachmentPath ?? '',
        attachmentFileType: rowData.attachmentFileType ?? '',
        outputFileName: rowData.outputFileName ?? '',
        dataSourceType: rowData.dataSourceType ?? '',
        dataSourceDef: rowData.dataSourceDef ?? '',
        postSendDataSourceType: rowData.postSendDataSourceType ?? '',
        postSendDataSourceDef: rowData.postSendDataSourceDef ?? '',
        emailTo: rowData.emailTo ?? '',
        ccTo: rowData.ccTo ?? '',
        bccTo: rowData.bccTo ?? '',
        aSubject: rowData.aSubject ?? '',
        aBody: rowData.aBody ?? '',
        waTemplateName: rowData.waTemplateName ?? '',
        waTemplate: rowData.waTemplate ?? '',
        waLanguageCode: rowData.waLanguageCode ?? '',
        dbConnid: rowData.dbConnid ?? 0,
        alertConfigId: rowData.alertConfigId ?? 0,
        schedularId: rowData.schedularId ?? 0,
        lastExecutedOn: rowData.lastExecutedOn ? new Date(rowData.lastExecutedOn) : null,
        nextExecutionTime: rowData.nextExecutionTime ? new Date(rowData.nextExecutionTime) : null,
        isActive: rowData.isActive ?? 1,
        isDeleted: rowData.isDeleted ?? 0,
        // Set visibility flags based on data
        showPostForm: !!(rowData.postSendDataSourceType || rowData.postSendDataSourceDef),
        showAddScheduler: !!rowData.schedularId
      })
    }
    else if (event.actionName === 'Delete') {
      this.confirmModal.openDeleteModal(rowData.title!, rowData).subscribe(res => {
        if (res) {
          this.deleteAlertService(rowData.serviceId);
        }
      })

    }
    else if (event.actionName === 'Enable Service' || event.actionName === 'Disable Service') {
      let data: AlertsServiceMasterUpdateStatusRequestDTO = {
        serviceId: rowData.serviceId,
        tenantId: rowData.tenantId ?? this.User.companyId,
        tenantBranchId: rowData.tenantBranchId ?? this.User.loggedInBranchId,
        actionUser: this.User.userId.toString()
      }

      this.alertServiceService.AlertServiceMaster_UpdateStatus(data).subscribe((res) => {
        const index = this.serviceList.findIndex(s => s.serviceId === res.serviceId);
        this.serviceList[index] = { ...res, statusText: res.isActive === 1 ? 'Active' : 'Inactive' };
      })
    }
    else if (event.actionName === 'Add Variable') {
      this.serviceVariableForm.reset;
      this.serviceVariableForm.patchValue({
        serviceId: rowData.serviceId
      })
      this.addServiceVariableModal = this.modalService.open(this.addServiceVariableModalContent);
    } else if (event.actionName === 'View') {
      let id = rowData.serviceId;
      this.router.navigate([`/notification/services/${id}`])
    }
  }

  submitServiceVaribaleForm() {
    if (this.serviceVariableForm.valid) {
      this.isServiceVariableFormSubmitted = true;
      let formData = this.serviceVariableForm.value;

      let data: AlertsServiceVariablesCreateRequestDTO = {
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        actionUser: this.User.userId.toString(),
        serviceId: formData.serviceId!,
        varInstance: formData.varInstance!,
        varValue: formData.varValue!,
        varType: formData.varType!
      }

      this.alertServiceVariable.AlertsServiceVariables_create(data).subscribe((res) => {
        this.addServiceVariableModal.close();
      this.isServiceVariableFormSubmitted = false;
      })
    }

  }

  deleteAlertService(serviceId: number) {
    let data: AlertsServiceMasterDeleteRequestDTO = {
      serviceId: serviceId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      actionUser: this.User.userId.toString()
    }

    this.alertServiceService.AlertServiceMaster_delete(data).subscribe((res) => {
      this.getAlertServiceList(this.PaginatedDTO);
    })
  }

  updateStatus(rows: any): string {
    if (rows.isActive == 0 && rows.isDeleted == 0) {
      return "Enable Service";
    } else {
      return "Disable Service";
    }


  }

  selectedTab: string = 'Grid';

  tabs = [
    {
      tabName: 'Tabular',
      tabIcon: 'fa fa-bars',
    },
    {
      tabName: 'Grid',
      tabIcon: 'fa fa-th',
    }
  ]

  // Wizard step state
  currentStep: number = 1;
  readonly wizardSteps = ['Basic Info', 'Channel Config', 'Data Source', 'Advanced'];

  alertTypes = [
    { value: 'Email',           label: 'Email',           icon: 'bi bi-envelope-fill' },
    { value: 'WhatsApp',        label: 'WhatsApp',        icon: 'bi bi-whatsapp' },
    { value: 'SMS',             label: 'SMS',             icon: 'bi bi-chat-dots-fill' },
    { value: 'MSTeams',         label: 'MS Teams',        icon: 'bi bi-microsoft-teams' },
    { value: 'PowerShellScript',label: 'PowerShell',      icon: 'bi bi-terminal-fill' },
    { value: 'Others',          label: 'Others',          icon: 'bi bi-three-dots' },
  ];

  nextStep() {
    if (this.currentStep < this.wizardSteps.length) this.currentStep++;
  }

  prevStep() {
    if (this.currentStep > 1) this.currentStep--;
  }

  get channelConfigRequired(): boolean {
    return ['Email', 'WhatsApp', 'SMS'].includes(this.alertServiceForm.get('alertType')?.value || '');
  }

  onTabSelect(arg0: string) {
    this.selectedTab = arg0
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { view: this.selectedTab },
      queryParamsHandling: 'merge', // Keeps existing query params if needed
      replaceUrl: true              // Prevents extra history entry
    });
  }
  loadData() {
    const searchValue = this.searchText?.trim() ?? '';

    this.PaginatedDTO = {
      ...this.PaginatedDTO,     // keep pageSize, companyId, branchId, softwareId
      whereClause: searchValue
        ? `(A.Title LIKE '%${searchValue}%')`
        : '',
      pageNo: 1 // reset page to 1
    };

    this.getAlertServiceList(this.PaginatedDTO);
  }


}

